import { InfraType } from 'app/agriculture/mutations/types/entityConfig';
import { FunctionComponent } from 'react';
import { GateFields } from 'app/agriculture/routes/Infra/components/fields/GateFields';
import { BridgeCrossingFields } from 'app/agriculture/routes/Infra/components/fields/BridgeCrossingFields';
import { PaddockFields } from 'app/agriculture/routes/Infra/components/fields/PaddockFields';
import { VegetationFields } from 'app/agriculture/routes/Infra/components/fields/VegetationFields';
import { DamFields } from 'app/agriculture/routes/Infra/components/fields/DamFields';
import { FenceFields } from 'app/agriculture/routes/Infra/components/fields/FenceFields';

interface InfraSpecificContentProps {
    infraType: InfraType;
}

const fieldsForInfra: Partial<Record<InfraType, FunctionComponent>> = {
    'Bridge Crossing': BridgeCrossingFields,
    Dam: DamFields,
    Fence: FenceFields,
    Gate: GateFields,
    Paddock: PaddockFields,
    Vegetation: VegetationFields,
};

export function InfraSpecificFields({ infraType }: InfraSpecificContentProps) {
    const InfraFields = fieldsForInfra[infraType];

    if (InfraFields == null) return null;

    return <InfraFields />;
}
